import React from 'react'
import AWS from "aws-sdk";
const useImageConfigS3 = () => {
   const bucketName =  process.env.REACT_APP_S3_BUCKET;
    const s3 = new AWS.S3({
        accessKeyId: process.env.REACT_APP_ACCESS_KEY,
        secretAccessKey: process.env.REACT_APP_SECRET_ACCESS_KEY,
        region: process.env.REACT_APP_REGION,
      });
  return [s3,bucketName]
}

export default useImageConfigS3